angular.module('createReferrals')
.controller('ReviewReferralsController', ['$scope', '$state', '$http', 'API_ENDPOINT', 'currentReferral', 'Notification', 'Auth', 'Procedure', 'Referral', 'UnsavedChanges', 'Logger', 'ReferralHelper', 'ReferralAutosave', 'User', 'message',
    function ($scope, $state, $http, API_ENDPOINT, currentReferral, Notification, Auth, Procedure, Referral, UnsavedChanges, Logger, ReferralHelper, ReferralAutosave, User, message) {

        var auth = $scope.auth =  Auth.get() || {};

        $scope.immediateUpdate = false;
        $scope.model = {referral: currentReferral};
        $scope.patient = currentReferral.patient;
        $scope.attachments = currentReferral.attachments;
        // Partial live drafts (DCL-369) may not have teeth/destination/procedure yet
        $scope.teeth = (currentReferral.teeth || '').split('+').filter(function (tooth) { return tooth; });
        $scope.procedures = Procedure.query();
        $scope.autosaveState = 'idle';
        currentReferral.notes = currentReferral.notes || [];
        currentReferral.notes_attributes = [];

        // Only fetch user data if auth.id is available to prevent unnecessary API calls
        if (auth.id) {
            User.get({id: auth.id}, function(user){
                $scope.providerLocations = user.addresses;
                if (user.addresses.length < 2){
                    $scope.disableLocations = true;
                    $scope.model.referral.orig_provider_address_id = user.addresses[0].id;
                }
            }, function(error) {
                // Silently handle authentication errors as authInterceptor will handle the redirect
                if (error.status !== 401 && error.status !== 403) {
                    Logger.log('Failed to load provider locations', error);
                }
            });
        }

        Procedure.practiceTypes().$promise.then(function (types) {
            $scope.practiceTypes = types;
            if (currentReferral.procedure) {
                ReferralHelper.updatePracticeType($scope, currentReferral.procedure.practice_type_id);
            }
        });

        if (currentReferral.dest_practice) {
            $scope.destinationPractice = currentReferral.dest_practice;
            $scope.destinationPractice.users.unshift({id:-1, first_name: 'First', last_name: 'Available', firstAvailable: true});
        } else if (currentReferral.dest_provider_invited) {
            $scope.destinationPractice = {users: [currentReferral.dest_provider_invited], name: '-- pending registration (' + currentReferral.dest_provider_invited.email + ') --'};
        }
        $scope.practiceSearchText = $scope.destinationPractice ? $scope.destinationPractice.name : '';

        ReferralHelper.watchProviders($scope);

        // ---- live-draft autosave (DCL-369) ----
        var autosave = ReferralAutosave.createSession({
            referralId: currentReferral.id,
            buildPayload: function () { return ReferralHelper.buildDraftPayload($scope); },
            onState: function (state) {
                $scope.autosaveState = state;
                // the review screen renders no inline indicator — the toast is its only failure signal
                if (state === 'failed') {
                    Notification.error('Changes could not be saved. Please check your connection and try again.');
                }
            },
            onSaved: function (data, sentPayload) { ReferralHelper.syncSavedNotes($scope, data, sentPayload); }
        });
        ReferralHelper.wireAutosave($scope, autosave, function (scope) {
            return ReferralHelper.buildDraftPayload(scope);
        });

        // The notes block disables its new-note and edit controls while a
        // save request is open, so nothing races the list it answers with (DCL-636).
        $scope.notesBusy = function () { return autosave.isRequestInFlight(); };

        // DCL-523: flush pending autosave before an upload, so a CBCT upload is
        // judged against the destination the user actually sees (see the same
        // hook in createReferralsController).
        $scope.ensureDraftForUpload = function () {
            return autosave.ensureDraftNow().then(function (referralId) {
                return autosave.flush().then(function () { return referralId; });
            });
        };

        $scope.sendReferral = function () {
            $scope.form.$setDirty();

            if ($scope.form.$invalid) {
                return false;
            }
            if ($scope.uploader && ($scope.uploader.isUploading || $scope.uploader.queue.length > 0)) {
                Notification.error('Please wait for attachments to finish uploading.');
                return false;
            }

            autosave.flush().then(function () {
                return $http.put(API_ENDPOINT + '/referrals/' + currentReferral.id + '/send', {}).then(function () {
                    Notification.success('Referral was sent successfully!');
                    UnsavedChanges.resetCbHaveUnsavedChanges(); // to make redirect
                    $state.go('viewReferral', {referral_id: currentReferral.id});
                });
            }).catch(function (failure) {
                var errorMessage = failure && failure.data && failure.data.message;
                Notification.error(errorMessage || 'An error occurred during referral creation...');
            });
        };

        $scope.discardTemplate = function (referral) {
            Referral.remove({id: referral.id},
                function (success) {
                    UnsavedChanges.resetCbHaveUnsavedChanges();
                    $state.go('history');
                }, function (failure) {
                    Notification.error('An error occurred during template removal. Please try again later.');
                });
        };
    }]);
